import type { MediaProvider } from '@atlaskit/editor-common/provider-factory';
import type { MediaPluginOptions } from '@atlaskit/editor-plugin-media';

interface Props {
	options: Pick<
		MediaPluginOptions,
		| 'altTextValidator'
		| 'featureFlags'
		| 'allowAdvancedToolBarOptions'
		| 'fullWidthEnabled'
		| 'editorAppearance'
		| 'waitForMediaUpload'
		| 'alignLeftOnInsert'
		| 'getEditorFeatureFlags'
		| 'forceHandlePositioning'
	>;
	providers: {
		mediaProvider: Promise<MediaProvider> | undefined;
	};
}

export function mediaPluginOptions({ options, providers }: Props): MediaPluginOptions {
	return {
		provider: providers.mediaProvider,
		allowMediaSingle: true,
		allowResizing: true,
		allowCaptions: true,
		forceHandlePositioning: options.forceHandlePositioning,
		altTextValidator: options.altTextValidator,
		featureFlags: options.featureFlags,
		// below values are copied from legacy preset to avoid regression
		allowLazyLoading: true,
		allowBreakoutSnapPoints: true,
		allowAdvancedToolBarOptions: options.allowAdvancedToolBarOptions,
		// originally value was Boolean(options.annotationProviders),
		allowCommentsOnMedia: true,
		allowDropzoneDropLine: true,
		allowMediaSingleEditable: true,
		allowRemoteDimensionsFetch: true,
		allowMarkingUploadsAsIncomplete: false,
		allowImagePreview: true,
		fullWidthEnabled: options.fullWidthEnabled,
		editorAppearance: options.editorAppearance,
		waitForMediaUpload: options.waitForMediaUpload,
		isCopyPasteEnabled: true,
		alignLeftOnInsert: options.alignLeftOnInsert,
		getEditorFeatureFlags: options.getEditorFeatureFlags,
	};
}
